import { createContext, useContext } from 'react';

const CampaignContext = createContext(null);

export function useCampaignContext() {
  const ctx = useContext(CampaignContext);
  if (!ctx) {
    throw new Error('useCampaignContext must be used within a CampaignProvider');
  }
  return ctx;
}

export default CampaignContext;
